import React from 'react';
import { assetPath } from '../assetPath';
import { LanguageSwitcher } from './LanguageSwitcher';

// Shared Header Component for public pages
const PublicHeader = ({ loginPath, t }) => (
  <header
    className="position-fixed w-100"
    style={{
      top: 0,
      left: 0,
      zIndex: 1000,
      background: 'white',
      boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
      borderBottom: '1px solid #f3f4f6',
    }}
  >
    <nav className="container">
      <div className="d-flex justify-content-between align-items-center py-3">
        {/* Logo */}
        <a href="/" className="d-flex align-items-center text-decoration-none">
          <img
            src={assetPath('powerkid-icon.png')}
            alt="PowerKid Logo"
            className="me-2"
            style={{ width: '40px', height: '40px' }}
          />
          <span className="fw-bold text-dark" style={{ fontSize: '24px' }}>
            PowerKid
          </span>
        </a>

        {/* Navigation buttons */}
        <div className="d-flex align-items-center gap-2">
          <LanguageSwitcher variant="light" />
          <a
            href={loginPath}
            className="btn btn-link text-dark text-decoration-none fw-medium"
          >
            {t('landing.nav.login')}
          </a>
          <a
            href={loginPath}
            className="btn fw-medium text-white"
            style={{
              background: 'linear-gradient(to right, #667eea, #764ba2)',
              borderRadius: '8px',
            }}
          >
            {t('landing.nav.getStarted')}
          </a>
        </div>
      </div>
    </nav>
  </header>
);

export default PublicHeader;
